<div class="sidebar-header flex-between"
     [ngClass]="{ 'sidebar-header--mini': !isMenuOpen }"
>
  <a class="sidebar-header__logo position-relative"
     (click)="redirectToRoleRespectiveDashboard()"
  >
    <ng-template [ngIf]="isMenuOpen" [ngIfElse]="miniLogoTemplate">
      <img class="logo" src="assets/img/v2/general/logo-dark.svg" alt="Trinity medical solutions logo"/>
    </ng-template>

    <ng-template #miniLogoTemplate>
      <img src="assets/img/v2/general/logo-mini.png"
           class="mini-logo"
           alt="Trinity medical solutions logo"
      />
    </ng-template>

  </a>

  <button class="sidebar-header__toggle"
          mat-button
          [attr.aria-label]="isMenuOpen ? 'Minimize sidebar' : 'Open sidebar'"
          [ngClass]="{ 'sidebar-header__toggle--rotated': isMenuOpen }"
          (click)="toggleIsMenuOpen()">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
